import { useUrlSync } from './useUrlSync.ts';

export const RouteSync = () => {
	useUrlSync();
	return null;
};
